import { useState } from 'react';

function useToken() {
    const getToken = () => {
        const tokenString = sessionStorage.getItem('token');

        try {
            return JSON.parse(tokenString);
        } catch {
            return tokenString || null;
        }
    };

    const [token, setToken] = useState(getToken());

    const saveToken = (userToken) => {

        // console.log('sssssssssssssss');
        // console.log(userToken.session.response_package_user);
        // console.log('kkkkkkkkkkk');
        // console.log(userToken.session.response_package_user);

        const authToken = userToken.session?.authToken || userToken;
        // const user_package_list = userToken.session.response_package_user;

        const userName = userToken.session?.name;
        const userApikey = userToken.session?.apiKey;
        sessionStorage.setItem('token', JSON.stringify(authToken));
        sessionStorage.setItem('userName', JSON.stringify(userName));
        sessionStorage.setItem('userApikey', JSON.stringify(userApikey));
        // sessionStorage.setItem('user_package_list',JSON.stringify(user_package_list));
        setToken(authToken);
    };

    return {
        token,
        setToken: saveToken,
    };
}

export default useToken;
